var exports = {
  "Vs": "OkeyTile.module__tile___OU5LZm",
  "ai": "OkeyTile.module__number___OU5LZm",
  "d4": "OkeyTile.module__star___OU5LZm",
  "kL": "OkeyTile.module__clover___OU5LZm",
  "Mx": "OkeyTile.module__plays___OU5LZm",
};

module.exports = exports;
